import { render, staticRenderFns } from "./AudiobooksListPage.vue?vue&type=template&id=3e12dade&scoped=true&"
import script from "./AudiobooksListPage.vue?vue&type=script&lang=ts&"
export * from "./AudiobooksListPage.vue?vue&type=script&lang=ts&"
import style0 from "./AudiobooksListPage.vue?vue&type=style&index=0&id=3e12dade&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e12dade",
  null
  
)

export default component.exports